import ColorFormatter from "./colorFormatter"

class customIDClassesGenerator {
  static instance = null;

  constructor() {
    if (customIDClassesGenerator.instance) {
      return customIDClassesGenerator.instance;
    }
    this.ColorFormatter = new ColorFormatter();
    customIDClassesGenerator.instance = this;
  }

  createClassesForIDColors(impactdriverStatuses) {
    const customIDStatuses = impactdriverStatuses.filter(impactDriverStatus => this.notDefaultImpactDriverStatus(impactDriverStatus))
    
    const IDStatusesWithNoColor = customIDStatuses.filter(customIDStatuse => !customIDStatuse.color);
    this.createClassesForDefaultIDColors(IDStatusesWithNoColor)

    const IDStatusesWithCustomColor = customIDStatuses.filter(customIDStatuse => customIDStatuse.color);
    this.createClassesForCustomIDColors(IDStatusesWithCustomColor)
  }

  createClassesForDefaultIDColors(IDStatusesWithNoColor) {
    if (IDStatusesWithNoColor.length) {
      const colorClasses = this.generateDefaultColorClass(IDStatusesWithNoColor);
      const cssString = this.generateCssString(colorClasses);
      this.saveCssString(cssString);
    }
  }
  createClassesForCustomIDColors(IDStatusesWithCustomColor) {
    if (IDStatusesWithCustomColor.length) {
      const colorClasses = this.generateColorClasses(IDStatusesWithCustomColor);
      const cssString = this.generateCssString(colorClasses);
      this.saveCssString(cssString);
    }
  }

  generateDefaultColorClass(IDStatusesWithNoColor) {
    const colorClasses = {};
    for (const status of IDStatusesWithNoColor) {
      colorClasses[`.${status.name.replaceAll(' ', '').toLowerCase()}`] = {
        'background-color': 'var(--el-color-info)',
        '--el-button-bg-color': 'var(--el-color-info)',
        '--el-button-hover-border-color': 'var(--el-color-info)',
      };
    }
    return colorClasses;
  }

  generateColorClasses(IDStatusesWithCustomColor) {
    const colorClasses = {};
    for (const status of IDStatusesWithCustomColor) {
      const currentStatusColor = status.color;

      colorClasses[`.${status.name.replaceAll(' ', '').toLowerCase()}`] = {
        '--el-button-text-color': `${ColorFormatter.isColorLight(currentStatusColor) ? 'var(--el-color-black)' : 'var(--el-color-white)'}`,
        'background-color': `${currentStatusColor}`, 
        '--el-button-bg-color': `${currentStatusColor}`,
        '--el-button-border-color': 'var(--el-color-white)',
        '--el-button-hover-border-color': `${currentStatusColor}`,
      };
    }
    return colorClasses;
  }

  generateCssString(colorClasses) {
    let cssString = '';
    for (const selector in colorClasses) {
      const styles = colorClasses[selector];
      let styleString = `${selector} {`;

      for (const property in styles) {
        styleString += `${property}: ${styles[property]};`;
      }

      styleString += `}`;
      cssString += styleString;
    }
    return cssString;
  }

  saveCssString(cssString) {
    if (cssString) {
      const styles = document.createElement('style');
      styles.innerHTML = cssString;
      document.head.appendChild(styles);
    }
  }

  static getInstance() {
    if (!customIDClassesGenerator.instance) {
      customIDClassesGenerator.instance = new customIDClassesGenerator();
    }
    return customIDClassesGenerator.instance;
  }

  notDefaultImpactDriverStatus(impactDriverStatus) {
    return !['None', 'Closed won', 'Closed lost', 'Pitched', 'Implemented'].includes(impactDriverStatus.name);
  }
}

export default customIDClassesGenerator;
